import { createFileRoute } from "@tanstack/react-router";
import { useEffect, useState } from "react";

export const Route = createFileRoute("/oauth/google-calendar/return")({
  head: () => ({
    meta: [
      { title: "Finishing Google Calendar connection | Leadership Edge Scheduling" },
      {
        name: "description",
        content: "Completes the Google Calendar authorization for a Leadership Edge Live trainer.",
      },
      { property: "og:title", content: "Finishing Google Calendar connection" },
      { property: "og:description", content: "Completes the Google Calendar authorization." },
      { property: "og:type", content: "website" },
      { name: "twitter:card", content: "summary" },
      { name: "robots", content: "noindex" },
    ],
  }),
  component: CalendarOAuthReturn,
});

function CalendarOAuthReturn() {
  const [message, setMessage] = useState("Finishing the connection…");

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const success = params.get("success") === "true";
    if (!success) setMessage(params.get("error") ?? "Google did not complete the connection.");

    window.opener?.postMessage(
      {
        type: success ? "calendarOAuthComplete" : "calendarOAuthFailed",
        connectorId: "google_calendar",
        error: params.get("error"),
      },
      window.location.origin,
    );
    window.close();
  }, []);

  return (
    <main className="flex min-h-screen items-center justify-center p-8">
      <p className="text-sm text-muted-foreground">{message}</p>
    </main>
  );
}
